import { render, staticRenderFns } from "./AccountOrderDetailsShipmentGrid.vue?vue&type=template&id=7f6a77f0&"
import script from "./AccountOrderDetailsShipmentGrid.vue?vue&type=script&lang=js&"
export * from "./AccountOrderDetailsShipmentGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports